import { Grid, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { campaignContact, campaignContactData, campaignContactFieldData, campaignContactTagAssignment, getCampaignContactListResponse, getCampaignContactPayload, tagDataInterface, updateCampaignContactFieldPyload } from '../../../models/axiosModel'
import { ContactContext, ContactContextPayload } from '../../../context/contactContext'
import { UserContext, UserContextPayload } from '../../../context/userContext'
import GlobalPopUp from '../../utility/globalPopUp'
import ContactFilterPopup from './contactFilterPopup'
import EditFieldPopup from './editFieldPopup';
import ContactPageHeader from './contactPageHeader'
import ContactTable from './contactTable'
import GlobalDeletePopup from '../../utility/globalDeletePopup/globalDeletePopup'
import { Moment } from 'moment'
import { useGenericStore } from '../../../store/genericStore'
import { useShallow } from 'zustand/react/shallow'
import { flagAddTagDialogObj } from './contactsGlobal'

interface ContactTableProps {
    deleteCampaignContact: (contacts: campaignContact[]) => void,
    editCampaignContact: (contacts: campaignContact[]) => void,
    selectedCampaignContactList: getCampaignContactListResponse,
    getCampaignContactApiCall: (list_id: number) => void;
    updateCampaignContactFieldApiCall: (payload: updateCampaignContactFieldPyload) => void,
    getListOfCampaignFieldTypeApiCall: () => void,
    deleteCampaignContactFieldApiCall: (contact_field_id: number) => void,
    setFlagAddTagDialogObj: React.Dispatch<React.SetStateAction<flagAddTagDialogObj>>,
}

export interface nameData {
    first_name_field_id: number,
    last_name_field_id: number,
    first_name: string,
    last_name: string,
    full_name: string,
}

export interface filtersInterface {
    phoneNumber: string[],
    name: string[],
    tags: string[],
    startDate: Moment | null;
    endDate: Moment | null;
    includeDeletedContacts: boolean,
}

export interface sortConfig {
    key: string,
    direction: string,
}

const ContactList: React.FC<ContactTableProps> = ({ deleteCampaignContact, editCampaignContact, selectedCampaignContactList, getCampaignContactApiCall, updateCampaignContactFieldApiCall, getListOfCampaignFieldTypeApiCall, deleteCampaignContactFieldApiCall, setFlagAddTagDialogObj }) => {

    const { campaignContactData, getFilteredContactApi, setFilteredCampaignContactData, campaignContactFieldData, campaignContactFieldTypeData } = useContext(ContactContext) as ContactContextPayload;
    const { flagLoading, setFlagLoading, handleError } = useContext(UserContext) as UserContextPayload;

    const { showError } = useGenericStore(useShallow((state) => ({
        showError: state.showError
    })))
    
    const [filters, setFilters] = useState<filtersInterface>({
        phoneNumber: [],
        name: [],
        tags: [],
        startDate: null,
        endDate: null,
        includeDeletedContacts: false
    })
    const [phoneNumberData, setPhoneNumberData] = useState<campaignContactData[]>([]);
    const [nameData, setNameData] = useState<nameData[]>([]);
    const [tagData, setTagData] = useState<campaignContactTagAssignment[]>([]);

    const [selectedNumberData, setSelectedNumberData] = useState<campaignContactData[]>([]);
    const [selectedNameData, setSelectedNameData] = useState<nameData[]>([]);
    const [selectedTagData, setSelectedTagData] = useState<campaignContactTagAssignment[]>([]);

    const [selectContact, setSelectContact] = useState<campaignContact[]>([]);

    const [flagFilterDialog, setFlagFilterDialog] = useState<boolean>(false);

    const [sortConfig, setSortConfig] = useState<sortConfig>({ key: "", direction: '' });

    const [flagEditFieldDialog, setFlagEditFieldDialog] = useState<boolean>(false);
    const [showDeleteFieldConfirmation, setShowDeleteFieldConfirmation] = useState<boolean>(false);

    const [requiredField, setRequiredField] = useState<campaignContactFieldData | null>(null);

    const [filteredContacts, setFilteredContacts] = useState<campaignContact[]>([]);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const breakPoints = {
        flagSmallScreen: useMediaQuery<boolean>('(min-width: 0px) and (max-width: 1000px)'),
    }

    const getFilteredCampaignContactPayload = () => {

        const campaign_data = [];
        const tag_data: number[] = [];
        const phoneNumberData = selectedNumberData.map((number) => {
            return ({
                contact_data_value: number.contact_data_value,
            })
        });
        const firstNameData = selectedNameData.map((name) => {
            return (
                { contact_data_value: name.first_name, }
            );
        })
        const lastNameData = selectedNameData.map((name) => {
            return (
                { contact_data_value: name.last_name, }
            );
        })
        const tagsData = selectedTagData.map((tag) => {
            tag_data.push(tag.contact_tag_id);
        })

        if (phoneNumberData.length > 0) {
            const obj = {
                contact_field_id: selectedNumberData[0].contact_field_id,
                contact_field_value: phoneNumberData,
            }
            campaign_data.push(obj);
        }
        if (firstNameData.length > 0) {
            const obj_firstName = {
                contact_field_id: selectedNameData[0].first_name_field_id,
                contact_field_value: firstNameData,
            }
            const obj_lastName = {
                contact_field_id: selectedNameData[0].first_name_field_id,
                contact_field_value: lastNameData,
            }
            campaign_data.push(obj_firstName);
            campaign_data.push(obj_lastName);
        }
        const payload: getCampaignContactPayload = {
            contact_list_id: selectedCampaignContactList.contact_list_id,
            contact_data: campaign_data,
            contact_tag_id: tag_data,
        }
        return payload;
    }

    const getFilteredContactApiCall = async (payload: getCampaignContactPayload) => {
        setFlagLoading({ ...flagLoading, flagRoundLoader: true });
        const response = await getFilteredContactApi(payload);
        if (!(response.status)) {
            handleError(response);
        }
        setFlagLoading({ ...flagLoading, flagRoundLoader: false });
    }

    const filterCampaignContact = () => {
        if (campaignContactData) {
            const filtered_contacts = campaignContactData.map((campaignResponse) => {
                const filteredContacts = campaignResponse.contact.filter((contact) => {
                    // Skip deleted contacts if checkbox is not checked
                    if (!filters?.includeDeletedContacts && contact.flag_deleted) {
                        return false;
                    }

                    const matchesNumberData =
                        selectedNumberData.length === 0 ||
                        selectedNumberData.some((phone) =>
                            contact.contact_data.some(
                                (data) => phone.contact_data_value === data.contact_data_value
                            )
                        );

                    const matchesNameData =
                        selectedNameData.length === 0 ||
                        selectedNameData.some((name) =>
                            contact.contact_data.some(
                                (data) => {
                                    const isFirstNameMatch = data.contact_field_name === "First Name" && selectedNameData.some((name) => name.first_name === data.contact_data_value);
                                    return isFirstNameMatch;
                                })
                        );

                    const matchedLastNameData = selectedNameData.length === 0 ||
                        selectedNameData.some((name) =>
                            contact.contact_data.some(
                                (data) => {
                                    const isLastNameMatch = data.contact_field_name === "Last Name" && selectedNameData.some((name) => name.last_name === data.contact_data_value);
                                    return isLastNameMatch;
                                })
                        );

                    const matchesTagData =
                        selectedTagData.length === 0 ||
                        selectedTagData.some((tags) =>
                            contact.contact_tag_assignment.some(
                                (tag) => tag.contact_tag_name === tags.contact_tag_name
                            )
                        );
                    return matchesNumberData && matchesNameData && matchedLastNameData && matchesTagData;
                });
                return {
                    ...campaignResponse,
                    contact: filteredContacts,
                };
            });
            setFilteredCampaignContactData(filtered_contacts);

            if (filtered_contacts?.[0]?.contact) {
                const filteredContactIds = new Set(
                    filtered_contacts[0].contact.map((contact) => contact.contact_id)
                );
                setSelectContact((prevSelected) =>
                    prevSelected.filter((contact) => filteredContactIds.has(contact.contact_id))
                );
            }
        }
    }

    useEffect(() => {
        if (campaignContactData && campaignContactData.length > 0) {
            let phoneNumber: campaignContactData[] = [];
            let name: nameData[] = [];
            let tag: campaignContactTagAssignment[] = [];

            const filteredInitialData = campaignContactData.map((list) => {
                const filteredContacts = list.contact.filter((contact) =>
                    filters?.includeDeletedContacts ? true : !contact.flag_deleted
                );

                filteredContacts.forEach(contact => {
                    let nameObj: nameData = {
                        first_name_field_id: 0,
                        last_name_field_id: 0,
                        first_name: "",
                        last_name: "",
                        full_name: "",
                    };

                    contact.contact_data.forEach(data => {
                        if (data.contact_field_name === "Phone Number" && !phoneNumber.some((phone) => phone.contact_data_value == data.contact_data_value)) {
                            phoneNumber.push(data);
                        } else if (data.contact_field_name === "First Name") {
                            nameObj.first_name = data.contact_data_value;
                            nameObj.first_name_field_id = data.contact_field_id;
                        } else if (data.contact_field_name === "Last Name") {
                            nameObj.last_name = data.contact_data_value;
                            nameObj.last_name_field_id = data.contact_field_id;
                        }
                    });

                    nameObj.full_name = [nameObj.first_name, nameObj.last_name].filter(Boolean).join(" ");
                    if (nameObj.full_name && !name.some((Name: nameData) => Name.full_name == nameObj.full_name)) name.push(nameObj);

                    contact.contact_tag_assignment.forEach(tagItem => {
                        if (!tag.find(t => t.contact_tag_id === tagItem.contact_tag_id)) {
                            tag.push(tagItem);
                        }
                    });
                });

                return {
                    ...list,
                    contact: filteredContacts,
                };
            });

            setFilteredCampaignContactData(filteredInitialData);
            setPhoneNumberData(phoneNumber);
            setNameData(name);
            setTagData(tag);
        }
    }, [campaignContactData, filters?.includeDeletedContacts]);

    // useEffect(() => {
    //     if (selectedNumberData.length > 0 || selectedNameData.length > 0 || selectedTagData.length > 0) {
    //         if (flagApplyFilter) {
    //             filterCampaignContact();
    //             setFlagApplyFilter(false);
    //         }
    //     } else {
    //         if (campaignContactData) {
    //             if (flagApplyFilter) {
    //                 // Filter out deleted contacts if checkbox is not checked
    //                 const filteredData = campaignContactData.map(list => ({
    //                     ...list,
    //                     contact: list.contact.filter(contact => includeDeletedContacts || !contact.flag_deleted)
    //                 }));
    //                 setFilteredCampaignContactData(filteredData);
    //                 setFlagApplyFilter(false);
    //             }
    //         }
    //     }
    // }, [selectedNumberData, selectedNameData, selectedTagData])

    const handleRefreshButtonClick = () => {
        const id = selectedCampaignContactList?.contact_list_id;
        if (id) {
            getCampaignContactApiCall(id);
            setSortConfig({ key: "", direction: "" });
        }
    }

    const downloadCSVFile = () => {
        if (filteredContacts && filteredContacts?.length > 0) {
            setFlagLoading({ ...flagLoading, flagRoundLoader: true });
            const headersSet = new Set<string>();
            // campaignContactData.forEach(list =>
            //     list.
                filteredContacts.forEach(contact =>
                    contact.contact_data.forEach(field =>
                        headersSet.add(field.contact_field_name)
                    )
                )
            // );
            const headers = Array.from(headersSet);

            // const rows = campaignContactData.flatMap(list =>
               const rows = filteredContacts.map(contact => {
                    const row: string[] = [];
                    headers.forEach(header => {
                        const field = contact.contact_data.find(
                            field => field.contact_field_name === header
                        );
                        row.push(field?.contact_data_value || "");
                    });
                    return row;
                })
            // );
            const list_name = selectedCampaignContactList.contact_list_name;

            const csvContent = [headers, ...rows].map(e => e.join(",")).join("\n");
            const blob = new Blob([csvContent], { type: "text/csv" });
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = `campaign_contact_of_${list_name}.csv`;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            setFlagLoading({ ...flagLoading, flagRoundLoader: false });
        } else {
            showError('No data available to download.')
        }
    }

    const deleteFieldApiCall = async (requiredField: campaignContactFieldData | null) => {
        if(requiredField){
            deleteCampaignContactFieldApiCall(requiredField?.contact_field_id);
            setShowDeleteFieldConfirmation(false); 
            setRequiredField(null);
        }
    }

    const handleClearFilter = () => {
        setSelectedNumberData([]);
        setSelectedNameData([]);
        setSelectedTagData([]);
        setFilters({
            phoneNumber: [],
            name: [],
            tags: [],
            startDate: null,
            endDate: null,
            includeDeletedContacts: false,
        })
        setFlagFilterDialog(false);
    }

    return (
        <>

            <GlobalPopUp
                open={flagFilterDialog}
                onClose={() => setFlagFilterDialog(false)}
                handleClose={() => setFlagFilterDialog(false)}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "80%" : "675px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "80%" : "725px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <ContactFilterPopup
                    setFlagFilterDialog={setFlagFilterDialog}
                    phoneNumberData={phoneNumberData}
                    nameData={nameData}
                    tagData={tagData}
                    filters={filters} 
                    setFilters={setFilters}
                    handleClearFilter={handleClearFilter}
                    setFlagAddTagDialogObj={setFlagAddTagDialogObj}
                />
            </GlobalPopUp>

            <GlobalPopUp
                open={flagEditFieldDialog}
                onClose={() => setFlagEditFieldDialog(false)}
                handleClose={() => setFlagEditFieldDialog(false)}
                flagShowCloseIcon={true}
                paperMinWidth={breakPoints.flagSmallScreen ? "310px" : "600px"}
                paperMaxwidth={breakPoints.flagSmallScreen ? "610px" : "650px"}
                borderRadius='10px'
                titlePadding='0px'
            >
                <EditFieldPopup
                    setFlagNewFieldDialog={setFlagEditFieldDialog}
                    getListOfCampaignFieldTypeApiCall={getListOfCampaignFieldTypeApiCall}
                    updateCampaignContactFieldApiCall={updateCampaignContactFieldApiCall}
                    requiredField={requiredField as campaignContactFieldData}
                    flagEdit={true}
                />
            </GlobalPopUp>

            {showDeleteFieldConfirmation && 
                <GlobalDeletePopup
                    deleteDescription={`Are you sure you want to delete ${requiredField?.contact_field_name}`}
                    open={showDeleteFieldConfirmation}
                    onClose={() => { setShowDeleteFieldConfirmation(false); setRequiredField(null); }}
                    onDelete={() => { deleteFieldApiCall(requiredField); }}
                />
            }

            <Grid container>
                <Grid item xs={12}>
                    <ContactPageHeader
                        filters={filters} 
                        setFilters={setFilters}
                        selectContact={selectContact} 
                        setSelectContact={setSelectContact}
                        deleteCampaignContact={deleteCampaignContact}
                        setFlagFilterDialog={setFlagFilterDialog}
                        downloadCSVFile={downloadCSVFile}
                        handleRefreshButtonClick={handleRefreshButtonClick} 
                        filteredContacts={filteredContacts}
                        handleClearFilter={handleClearFilter}
                        searchQuery={searchQuery}
                        setSearchQuery={setSearchQuery}
                    />
                </Grid>
                <Grid container mt={2}>
                    <Grid item xs={12}>
                        {campaignContactData && campaignContactData.length > 0 && campaignContactFieldData && 
                            <ContactTable
                                selectContact={selectContact}
                                setSelectContact={setSelectContact}
                                editCampaignContact={editCampaignContact}
                                deleteCampaignContact={deleteCampaignContact}
                                setRequiredField={setRequiredField}
                                setFlagEditFieldDialog={setFlagEditFieldDialog}
                                filters={filters}
                                sortConfig={sortConfig}
                                setSortConfig={setSortConfig} 
                                setFilteredContacts={setFilteredContacts} 
                                setShowDeleteFieldConfirmation={setShowDeleteFieldConfirmation}
                                searchQuery={searchQuery}
                            />
                        }
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ContactList

